import Image from 'next/image'
import Link from 'next/link'
import styles from './styles.module.scss'
import clsx from 'clsx'
import { simplifyUrl } from 'src/utils/url'
import { socialTypes } from 'src/consts'
import { exchangeReferalMap } from '../../config'
import { intl } from 'src/i18n'

export const GeneralInfoBlock = ({ data }) => {
  const {
    slug,
    extra,
    country,
    fiatDeposit,
    marginTrading,
    exchangesReferrals,
    coreType,
  } = data
  const { social, info, established, pairs, website } = extra || {}
  const referal = exchangeReferalMap[slug]
  const community = social?.filter(el => socialTypes.includes(el.type))

  return (
    <div className={styles.linksPart}>
      {info && info?.length > 0 && (
        <div className={styles.linksItem}>
          <div className={styles.label}>
            {intl.t('exchangeDetails.components.generalInfoBlock.label1')}
          </div>
          <div className={styles.linksItemContent}>
            {info.slice(0, 4).map(exp => {
              if (!(exp && typeof exp === 'string')) {
                return null
              }
              return (
                <a
                  href={exp}
                  target='_blank'
                  rel='noopener noreferrer nofollow'
                  key={exp}
                >
                  {simplifyUrl(exp)}
                </a>
              )
            })}
          </div>
        </div>
      )}

      {established && country && (
        <div className={styles.linksItem}>
          <div className={styles.label}>
            {intl.t('exchangeDetails.components.generalInfoBlock.label2')}
          </div>
          <div className={styles.linksItemContent}>
            <span>
              {country}, {established}
            </span>
          </div>
        </div>
      )}
      {coreType !== 'Decentralized' && (
        <>
          <div className={styles.linksItem}>
            <div className={styles.label}>
              {intl.t('exchangeDetails.components.generalInfoBlock.label3')}
            </div>
            <div className={styles.linksItemContent}>
              <span>{fiatDeposit.replace('N/A', '-') || '-'}</span>
            </div>
          </div>

          <div className={styles.linksItem}>
            <div className={styles.label}>
              {intl.t('exchangeDetails.components.generalInfoBlock.label4')}
            </div>
            <div className={styles.linksItemContent}>
              <span>{marginTrading.replace('N/A', '-') || '-'}</span>
            </div>
          </div>
        </>
      )}
      {pairs > 0 && (
        <div className={styles.linksItem}>
          <div className={styles.label}>
            {intl.t('exchangeDetails.components.generalInfoBlock.label5')}
          </div>
          <div className={styles.linksItemContent}>
            <span>{pairs || 'N/A'}</span>
          </div>
        </div>
      )}

      {(website || community?.length > 0) && (
        <div className={clsx(styles.linksItem, styles.last)}>
          <div className={styles.label}>
            {intl.t('exchangeDetails.components.generalInfoBlock.label6')}
          </div>

          <div className={styles.links}>
            <div className={styles.linksItemContent}>
              <Link
                href={
                  (exchangesReferrals &&
                    exchangesReferrals[slug] &&
                    exchangesReferrals[slug].link) ||
                  referal
                    ? referal
                    : website
                }
                legacyBehavior
              >
                <a target='_blank' rel='noopener noreferrer nofollow'>
                  {simplifyUrl(website)}
                </a>
              </Link>
            </div>

            <div
              className={clsx(styles.linksCommunity, {
                [styles.movedToBottom]: !!website,
              })}
            >
              {community?.map(({ link, type }) => {
                return (
                  <Link href={link} key={type} legacyBehavior>
                    <a
                      className={clsx(styles.communityItem, styles[type])}
                      target='_blank'
                      rel='noopener noreferrer nofollow'
                    >
                      <Image
                        src={`/assets/social/icon-${type}-white.svg`}
                        width='19'
                        height='19'
                        alt={`${type} icon`}
                      />
                    </a>
                  </Link>
                )
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default GeneralInfoBlock
